
<template>

    <DIV class="ButtonContainer PictureUpload">

        <span style="width:auto;text-align:center"
              :style="{opacity:m_Enabled?1:0.3}"
              class="Upload Button">{{ButtonText}}</span>

        <input type="file"
               :accept="Accept"
               :disabled="!m_Enabled"
               style="width: 100%; opacity: 0; filter:alpha(opacity=0); position: absolute; z-index:1;left:0px;top:0px"
               @change="OnMultiPictureSelect" :multiple="multiple=='true'||multiple==null?true:false" />

    </DIV>

</template>

<script>
    import Utility from '@/Common/Utility'
    import apiService from '@/Common/ApiService';
    import UploadManager from '@/Common/UploadManager';

    export default {
        data() {
            return {
                CheckPictureLoadedInterval: null,
                SeedNo: 1,
                ButtonText: "上傳",
                LastClickCheckBoxTime: new Date("2000/1/1"),

                m_Enabled: true,
                ItemElements: null,
                mouseDown: false,
                DraggingState: "Ready",
                isPreparePreviewImageRunning: false,
                Items: [

                ],
                PicturePathsText: ""

            };
        }
        ,
        props: ["value", "text", "TargetFolderPath", "KeepBaseName", "multiple", "MaxFiles", "MaxTotalSize",
            "FileExtensions", "Accept", "CheckUploadHandler",
            "disabled",
            "Enabled"
        ],


        computed: {


        }
        ,

        methods: {

            OnValueChange() {

            },

            //#region Upload Tasks
            OnMultiPictureSelect(e) {
                let fileElement;
                let uploadPageUrl;
                let _uploadPageUrl = "";
                let item = null;
                let itemHtml = "";
                let allUploadItemsHtml = "";
                let newItems = [];
                let i;


                this.Items.length = 0;

                if (window.location.href.indexOf("localhost:") > 0) {
                    uploadPageUrl = Utility.GetBaseUrl() + "/File/Upload";
                }
                else {
                    uploadPageUrl = Utility.GetBaseUrl() + Utility.PrefixUrl("/File/Upload");
                }

                Utility.SaveSession("Uploading", true);


                fileElement = e.target;

                if (fileElement.files.length == 0) {
                    return;
                }


                if (this.CheckUploadHandler != null) {
                    if (!this.CheckUploadHandler(fileElement.files)) {
                        return;
                    }
                }


                if (this.MaxFiles != undefined) {
                    if (fileElement.files.length > this.MaxFiles) {
                        this.$emit("UploadError", "MaxFiles");
                        this.$emit("ItemsCreate", []);
                        return;
                    }
                }
                if (this.MaxTotalSize != undefined) {
                    let sum = Array.from(fileElement.files)
                        .reduce((accumulator, object) =>
                            accumulator + (Math.round(object.size / 1024 / 1024 * 100) / 100 || 0),
                            0);
                    if (sum > this.MaxTotalSize) {
                        this.$emit("UploadError", "MaxTotalSize");
                        this.$emit("ItemsCreate", []);
                        return;
                    }
                }
                if (this.FileExtensions != undefined) {
                    const ext = Array.from(fileElement.files)
                        .filter(x => !this.FileExtensions.includes(Utility.GetFileExtension(x.name)));
                    if (ext.length > 0) {
                        this.$emit("UploadError", "FileExtensions");
                        this.$emit("ItemsCreate", []);
                        return;
                    }
                }

                UploadManager.Suspend();
                UploadManager.RemoveAllTasks();

                if (typeof (fileElement.files) != "undefined") {
                    for (i = 0; i < fileElement.files.length; i++) {
                        let task;

                        task = UploadManager.CreateTask(fileElement.files[i]);
                        if (this.TargetFolderPath != null) {
                            task.TargetFolderPath = this.TargetFolderPath;
                        }


                        if (this.KeepBaseName == "true" || this.KeepBaseName == true) {
                            task.KeepBaseName = true;
                        }
                        else {
                            task.KeepBaseName = false;
                        }

                        task.AutoRename = true;

                        item = new Object();

                        item.Checked = false;
                        item.TaskId = task.TaskId;
                        item.Task = task;
                        item.Type = "Image";
                        item.Progress = "Uploading ..";
                        item.FullName = "";
                        item.TaskId = task.Id;
                        item.Status = task.Status;

                        item.PicturePath = task.TempFileName;
                        //itemHtml = this.RenderItem(item);

                        this.Items.push(item);

                        newItems.push(item);

                        task.UploadPageUrl =
                            uploadPageUrl + "?" +
                            "RenamePolicy=AutoIndex"
                            ;
                    }
                }
                else {
                    task = this.UploadManager.CreateTask(fileElement);

                    if (this.TargetFolderPath != null) {
                        task.TargetFolderPath = this.TargetFolderPath;
                    }

                    if (this.KeepBaseName == "true" || this.KeepBaseName == true) {
                        task.KeepBaseName = true;
                    }
                    else {
                        task.KeepBaseName = false;
                    }

                }

                UploadManager.TaskProgressChange = this.OnTaskProgressChange;
                UploadManager.TaskSuccess = this.OnTaskSuccess;
                UploadManager.TaskFail = function (taskId, responseText) {
                    this.OnTaskFail(taskId, responseText);
                }.bind(this);

                UploadManager.AllTaskCompleted = this.OnAllTaskCompleted;

                fileElement.value = "";

                UploadManager.Resume();

                UploadManager.ExecuteUploadTasks();

                Utility.ShowLoadingPicture();
                setTimeout(
                    () => {
                        this.PrepareImagePreview()
                    },
                    100
                );

                //this.$emit("ItemsCreate", this.Items);
                this.$emit("ItemsCreate", newItems);

            },



            OnTaskProgressChange(taskId, progress) {
                let task;
                let items = [];
                let item;
                let responseObj;

                items = this.Items.filter(
                    (item) => {
                        return item.TaskId == taskId;
                    }
                );


                if (items.length > 0) {
                    item = items[0];

                    item.Progress = progress + "%";

                    item.Status = "Running";

                    this.$emit("ItemChange", item);
                }
            },

            OnTaskFail(taskId, responseText) {
                let task;
                let items = [];
                let item;
                let responseObj;


                task = UploadManager.GetTask(taskId);

                items = this.Items.filter(
                    (item) => {
                        return item.TaskId == task.Id;
                    }
                );

                if (items.length > 0) {
                    item = items[0];

                    item.ErrorMessage = responseText;
                    item.Progress = "Fail";
                    item.Status = "Fail";


                    this.$emit("ItemChange", item);
                    this.$emit("ItemFail", item);
                }

                this.$forceUpdate();
            },

            OnTaskSuccess(taskId, responseText) {
                let task;
                let items = [];
                let item;
                let responseObj;


                task = UploadManager.GetTask(taskId);

                responseObj = JSON.parse(task.XmlHttp.responseText);

                //responseObj.FilePath;


                items = this.Items.filter(
                    (item) => {
                        return item.TaskId == task.Id;
                    }
                );

                if (items.length > 0) {
                    item = items[0];
                    item.PicturePath = Utility.PrefixUrl(responseObj.FilePath);

                    item.Progress = "100%";
                    item.Status = "Stop";

                    this.$emit("ItemChange", item);
                    this.$emit("ItemComplete", item);

                }

                this.$forceUpdate();

                this.OnValueChange();
            },

            OnAllTaskCompleted() {

                Utility.HideLoadingPicture();

                this.OnValueChange();
                this.$emit("AllTaskComplete", this.Items);

                this.$emit("ItemsComplete", this.Items);
            },



            PrepareImagePreview() {
                if (this.isPreparePreviewImageRunning) {
                    return;
                }
                else {
                    this.PrepareImagePreviewImpl();
                }
            },


            PrepareImagePreviewImpl() {
                let task;
                let items;
                let item;
                var i;


                this.isPreparePreviewImageRunning = true;

                for (i = 0; i < UploadManager.Tasks.length; i++) {
                    task = UploadManager.Tasks[i];

                    if (task.Status != "Stop") {

                        items = this.Items.filter(
                            (item) => {
                                return item.TaskId == task.Id;
                            }
                        );

                        if (items.length > 0) {
                            item = items[0];


                            if (
                                (item.PicturePath == null || item.PicturePath == "") &&
                                task.TempFileName != ""
                            ) {
                                item.PicturePath = task.TempFileName;

                                this.$emit("ItemChange", item);
                                this.$emit("ItemPreview", item);
                            }

                        }
                    }

                }//end for (i = 0; i < UploadManager.Tasks.length; i++) {


                if (UploadManager.Tasks.length > 0) {
                    setTimeout(
                        function () {
                            this.PrepareImagePreviewImpl();
                        }.bind(this)
                        ,
                        1000
                    );
                }
                else {
                    this.isPreparePreviewImageRunning = false;
                }

                this.$forceUpdate();

            },

            //#endregion

        },

        created() {
            if (this.text != null) {
                this.ButtonText = this.text;
            }


            if (this.disabled == true || this.disabled == "true") {
                this.m_Enabled = false;
            }
            else {
                this.m_Enabled = true;
            }

            if (this.disabled == null) {
                if (this.Enabled == null || this.Enabled == true || this.Enabled == "true") {
                    this.m_Enabled = true;
                }
                else {
                    this.m_Enabled = false;
                }
            }
        },

        watch: {

            disabled(newVal) {
                if (newVal == true || newVal == "true") {
                    this.m_Enabled = false;
                }
                else {
                    this.m_Enabled = true;
                }
            },

            Enabled(newVal) {
                if (newVal == true || newVal == "true") {
                    this.m_Enabled = true;
                }
                else {
                    this.m_Enabled = false;
                }
            },
        }


    }
</script>

<style scoped>
    .ButtonContainer {
        position: relative;
        display: inline-block;
    }

        .ButtonContainer > .Button {
            line-height: 22px;
        }

        .ButtonContainer:hover > .Button {
            background-color: rgb(100, 100, 100);
            color: white;
        }
</style>
